// libs
import { Link } from "react-router-dom";
//@ts-ignore
import styled from "styled-components";

// components
import { Avatar, NotificationIcon } from "components/common";

// types
import type { User } from "model/User";

interface ReportPageRightHeaderProps {
  userInfo: User;
}

export const ReportPageRightHeader = ({
  userInfo,
}: ReportPageRightHeaderProps) => {
  return (
    <RightWrap>
      <NotificationIcon mode="light" />
      <Link to="/all">
        <Avatar src={userInfo.imageUrl} size={32} minSize={false} />
      </Link>
    </RightWrap>
  );
};

const RightWrap = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 18px;
`;
